<!-- Mobile Header -->
<div class="mobile-header">
  <div class="menu-btn" (click)="toggleMobileMenu()">
    <!-- Note: Ensure you have a menu icon or use an existing one -->
    <img src="assets/images/menu.svg" alt="Menu" />
  </div>
</div>

<!-- Backdrop -->
<div class="sidebar-backdrop" [class.open]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<div class="sidebar" [class.collapsed]="isCollapsed" [class.mobile-open]="isMobileMenuOpen">



  <!-- Toggle Button -->
  <div class="collapse-btn" (click)="toggleSidebar()">
    <img [src]="isCollapsed ? 'assets/images/zoomOut.svg' : 'assets/images/zoom.svg'" class="toggle-icon"
      alt="toggle" />
  </div>

  <!-- Logo -->
  <div class="logo" *ngIf="!isCollapsed">
    <img [src]="isDarkMode ? 'assets/images/logoDarkMode.svg' : 'assets/images/logo.svg'" alt="BANXX"
      class="logo-img" />
  </div>

  <!-- Main Menu -->
  <nav class="menu">
    <div *ngFor="let item of menuItems" [routerLink]="item.route" routerLinkActive="active"
      [ngClass]="isCollapsed ? 'menu-item1' : 'menu-item'" (click)="closeMobileMenu()">
      <div class="icon-wrapper">
        <img [src]="item.icon" alt="" />
      </div>
      <span>{{ item.label }}</span>
    </div>
  </nav>

  <!-- Theme Toggle -->
  <!-- Theme Toggle -->
  <div [ngClass]="isCollapsed ? 'menu-item1' : 'menu-item'" (click)="toggleTheme()">
    <div class="icon-box">
      <img [src]="isDarkMode ? 'assets/images/light-mode.svg' : 'assets/images/dark-mode.svg'" />
    </div>
    <span>{{ isDarkMode ? 'Dark Mode' : 'Light Mode' }}</span>
  </div>

  <!-- Bottom -->
  <div class="bottom">
    <div *ngFor="let action of bottomActions" [routerLink]="action.route" routerLinkActive="active"
      [ngClass]="isCollapsed ? 'menu-item1' : 'menu-item'" (click)="closeMobileMenu()">
      <div class="icon-box" [class.avatar]="action.isAvatar">
        <img [src]="action.icon" [class.avatar-img]="action.isAvatar" />
      </div>
      <span>{{ action.label }}</span>
    </div>
  </div>
</div>